import { render, staticRenderFns } from "./TituloAulas.vue?vue&type=template&id=a4557dfc&"
import script from "./TituloAulas.vue?vue&type=script&lang=js&"
export * from "./TituloAulas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports